module.exports = __webpack_public_path__ + "img/question17.d33c3773.png";